export default "__VITE_PUBLIC_ASSET__39f1e89d__"